import {
  DashboardPage,
  ComplaintsPage,
  BusinessPermitsPage,
  DisputesPage,
  ResidentsPage,
  DocumentsPage,
  CommunityServicesPage,
  VotersPage,
  InstitutionsPage,
  LegislationPage,
  AyudaPage,
} from "../../pages/admin"

export const adminRoutes = [
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/residents/*", element: <ResidentsPage /> },
  { path: "/documents/*", element: <DocumentsPage /> },
  { path: "/disputes/*", element: <DisputesPage /> },
  { path: "/complaints/*", element: <ComplaintsPage /> },
  { path: "/voters/*", element: <VotersPage /> },
  { path: "/community/*", element: <CommunityServicesPage /> },
  { path: "/institutions/*", element: <InstitutionsPage /> },
  { path: "/legislation/*", element: <LegislationPage /> },
  { path: "/business/*", element: <BusinessPermitsPage /> },
  { path: "/ayuda/*", element: <AyudaPage /> },
]
